import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-affebdbe"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "form-item-container" }
const _hoisted_2 = { class: "text-container" }
const _hoisted_3 = { class: "text-primary-language" }
const _hoisted_4 = {
  key: 0,
  class: "text-secondary-language"
}
const _hoisted_5 = { class: "text-area-container" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.question_lang1), 1),
      (_ctx.bilingue)
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, _toDisplayString(_ctx.question_lang2), 1))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_5, [
      _withDirectives(_createElementVNode("textarea", {
        rows: "5",
        maxlength: "500",
        minlength: "3",
        spellcheck: "true",
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.userTypedText) = $event))
      }, "\n            ", 512), [
        [_vModelText, _ctx.userTypedText]
      ])
    ])
  ]))
}